export const surfaceRangeOptions = [
  { label: "0–200 m²", min: 0, max: 200 },
  { label: "200–1000 m²", min: 200, max: 1000 },
  { label: "Plus de 1000 m²", min: 1000, max: null },
];

export function findSurfaceRangeByLabel(label) {
  if (!label) return undefined;
  return surfaceRangeOptions.find((option) => option.label === label);
}

export function matchSurfaceRangeFromValue(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return undefined;

  return surfaceRangeOptions.find((option) => {
    if (option.max === null) return numeric >= option.min;
    return numeric >= option.min && numeric <= option.max;
  });
}

export function surfaceRangeToNumeric(range) {
  if (!range) return undefined;
  const min = Number(range.min);
  const max = typeof range.max === "number" ? Number(range.max) : null;

  if (!Number.isFinite(min)) return undefined;
  if (Number.isFinite(max)) {
    return Math.round((min + max) / 2);
  }
  return min;
}

export function formatSurfaceRange(range) {
  return range?.label || "";
}
